export const createHtml = (
  encoded: string,
  blank?: boolean,
): { __html: string } => ({
  __html: `<a href="mailto:${encoded}" target="${
    blank ? '_blank' : '_self'
  }">${encoded}</a>`,
});

// https://gist.github.com/CatTail/4174511
export const encode = (email: string): string => {
  const buffer = [];

  for (let i = email.length - 1; i >= 0; i--) {
    buffer.unshift(`&#${email.charCodeAt(i)};`);
  }

  return buffer.join('');
};
